import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { REACT_APP_API_PORT } from "../Api";
import Loader from "../components/Loader";
import { useNavigate } from "react-router";
import { IoIosRefreshCircle } from "react-icons/io";
import { Helmet } from "react-helmet";

const FeedbackForm = (props) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState([]);
  const [isLoading, setisLoading] = useState(false);

  const getData = async () => {
    try {
      setisLoading(true);

      const res = await axios.get(
        `${REACT_APP_API_PORT}user/homepage/contactus-page-details`
      );

      setisLoading(false);

      if (res.data.status) {
        setData(res.data.data);
      }
    } catch (err) {
      setisLoading(false);
      console.log(err);
    }
  };

  const fetchMetaData = async () => {
    try {
      setisLoading(true);

      const res = await axios.get(
        `${REACT_APP_API_PORT}user/homepage/page-seo-details/Contactus Page`
      );

      if (res.data.status) {
        setMeta(res.data.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    getData();
    fetchMetaData();
  }, []);

const isSuspiciousEmail = (email) => {
  if (!email) return true;

  const value = email.trim().toLowerCase();
  const parts = value.split("@");

  if (parts.length !== 2) return true;

  const [username, domain] = parts;

  // Gmail should only use gmail.com
  if (
    domain === "gmail.co" ||
    domain === "gmail.net" ||
    domain === "gmail.org"
  ) {
    return true;
  }

  // Obvious dummy usernames
  if (
    /^(test|testing|tester|dummy|demo|fake|asdf|qwerty|sample|example)\d*$/i.test(
      username
    )
  ) {
    return true;
  }

  // Repeated characters
  if (/^(.)\1{3,}$/i.test(username)) {
    return true;
  }

  return false;
};


  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phoneNumber: "",
      which_course_join: "",
      Describe_issue: "",
    },

    validationSchema: Yup.object({
      name: Yup.string().required("Full Name is required"),

      email: Yup.string()
  .trim()
  .email("Please enter a valid email address")
  .required("Email is required")
  .test(
    "real-email",
    "Please enter a valid personal email address",
    (value) => !isSuspiciousEmail(value)
  ),

     phoneNumber: Yup.string()
  .trim()
  .required("WhatsApp Number is required")
  .test(
    "valid-international-whatsapp",
    "Please enter a valid WhatsApp number with country code",
    (value) => {
      if (!value) return false;

      // Remove spaces, brackets, hyphens and other formatting
      const cleaned = value.replace(/[\s\-().]/g, "");

      // International phone number:
      // +91XXXXXXXXXX
      // +1XXXXXXXXXX
      // +44XXXXXXXXXX
      // +971XXXXXXXXX
      //
      // 8 to 15 digits after +
      if (!/^\+[1-9]\d{7,14}$/.test(cleaned)) {
        return false;
      }

      // Reject numbers containing only the same digit
      const digits = cleaned.substring(1);

      if (/^(\d)\1+$/.test(digits)) {
        return false;
      }

      return true;
    }
  ),
      which_course_join: Yup.string().required(
        "Please select which course you joined"
      ),

      Describe_issue: Yup.string().required(
        "Please describe your doubt or issue"
      ),

    }),
     onSubmit: (values) => {
      handleSubmit(values);
    },

    
  });

  const handleSubmit = async (values) => {
    try {
      setisLoading(true);

      const res = await axios.post(
        `${REACT_APP_API_PORT}user/frontend/user_feedback_request`,
        {
          name: values.name,
          email: values.email,
          phone: values.phoneNumber,
          which_course_join: values.which_course_join,
          Describe_issue: values.Describe_issue,
        }
      );

      setisLoading(false);

      if (res.data.status) {
        props.setAlertBox(true);
        props.showAlert(res.data.message, "success");

        formik.resetForm();
       
      
      }
    } catch (err) {
      console.log(err);

      setisLoading(false);

      if (err.response?.data?.status === false) {
        props.setAlertBox(true);
        props.showAlert(err.response.data.message, "error");
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>Feedback & Support | Satyam AI</title>

        <meta
          name="description"
          content="Share your feedback, ask questions, and get support related to Satyam AI courses, tools, and learning experience."
        />

        <meta
          name="keywords"
          content="Satyam AI feedback, AI course support, AI learning support, ChatGPT doubts, Gemini doubts, Claude doubts, AI courses"
        />
      </Helmet>

      <Loader isLoading={isLoading} />

      <div className="relative bg-background-back1 py-12 pt-10">
        <div className="flex flex-col items-center justify-center gap-2 sm:gap-3 lg:gap-4 xl:gap-6">
        <div className="flex items-center gap-3">

          {/* Profile Image */}
          <div className="w-10 h-10 rounded-full overflow-hidden">
            <img
              src="/images/satyamprofile_121.jpg"
              alt="Satyam"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Brand Name */}
          <h3 className="text-lg sm:text-xl font-extrabold tracking-wide text-white">
            Satyam{" "}
            <span className="text-[#f55fff]">AI</span>
          </h3>

        </div>
        

          {/* MAIN CONTENT */}
          <div className="lg:w-[65%] w-full lg:px-0 px-3">

            {/* INTRO TEXT */}
            <div className="mt-3 text-center text-sm sm:text-base lg:text-lg text-gray-300 px-2 lg:px-8 leading-relaxed">
              <strong className="text-white">
                कोई भी Problem है? मुझे Directly बताओ — <br/> मैं खुद आपसे बात करूँगा. ❤️
              </strong>
            </div>

            {/* FORM CARD */}
            <div className="mt-7 rounded-2xl border border-white/10 bg-background-back2/30 shadow-2xl shadow-black/20 overflow-hidden">

             

              <form
                className="p-5 sm:p-7 lg:p-8 space-y-7"
                onSubmit={formik.handleSubmit}
              >

                {/* PERSONAL DETAILS */}
                <div>
                  {/* <div className="mb-4">
                    <h3 className="text-base font-semibold text-white">
                      Your Details
                    </h3>

                    <p className="text-xs sm:text-sm text-gray-400 mt-1">
                      So our team knows how to reach you.
                    </p>
                  </div> */}

                  {/* FULL NAME */}
                  <div className="space-y-2">
                    <label
                      className="text-sm font-medium text-gray-200"
                      htmlFor="name"
                    >
                      Full Name <span className="text-red-500">*</span>
                    </label>

                    <input
                      className="flex h-11 w-full bg-[#151515] border border-white/10 text-white rounded-xl px-4 py-2.5 outline-none transition-all placeholder:text-gray-500 focus:border-blue-500/70 focus:ring-2 focus:ring-blue-500/10"
                      placeholder="Enter your full name"
                      id="name"
                      name="name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                    />

                    {formik.touched.name && formik.errors.name && (
                      <p className="text-red-500 text-sm">
                        {formik.errors.name}
                      </p>
                    )}
                  </div>

                  {/* EMAIL + WHATSAPP */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-5">

                    {/* EMAIL */}
                    <div className="space-y-2">
                      <label
                        className="text-sm font-medium text-gray-200"
                        htmlFor="email"
                      >
                        Email <span className="text-red-500">*</span>
                      </label>

                      <input
                        className="flex h-11 w-full bg-[#151515] border border-white/10 text-white rounded-xl px-4 py-2.5 outline-none transition-all placeholder:text-gray-500 focus:border-blue-500/70 focus:ring-2 focus:ring-blue-500/10"
                        placeholder="you@example.com"
                        id="email"
                        name="email"
                        type="email"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.email}
                      />

                      {formik.touched.email && formik.errors.email && (
                        <p className="text-red-500 text-sm">
                          {formik.errors.email}
                        </p>
                      )}
                    </div>

                    {/* WHATSAPP NUMBER */}
                    <div className="space-y-2">
                      <label
                        className="text-sm font-medium text-gray-200"
                        htmlFor="phoneNumber"
                      >
                        WhatsApp Number{" "}
                        <span className="text-red-500">*</span>
                      </label>

                      <input
                        className="flex h-11 w-full bg-[#151515] border border-white/10 text-white rounded-xl px-4 py-2.5 outline-none transition-all placeholder:text-gray-500 focus:border-blue-500/70 focus:ring-2 focus:ring-blue-500/10"
                        placeholder="Enter WhatsApp number"
                        id="phoneNumber"
                        name="phoneNumber"
                        type="tel"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.phoneNumber}
                      />

                      {formik.touched.phoneNumber &&
                        formik.errors.phoneNumber && (
                          <p className="text-red-500 text-sm">
                            {formik.errors.phoneNumber}
                          </p>
                        )}
                        <p className="text-xs text-gray-500 mt-1">
  Include your country code, e.g. +91 for India.
</p>
                    </div>
                  </div>
                </div>

                {/* COURSE */}
               <div className="border-t border-white/10 pt-6">

  <div className="mb-4">
    <label className="text-sm font-medium text-gray-200">
      Which course are you enrolled in?
      <span className="text-red-500"> *</span>
    </label>
  </div>

  <div className="grid grid-cols-2 gap-3">

    {/* MEMBERSHIP */}
    <label
      className={`flex items-center gap-3 p-4 rounded-xl border cursor-pointer transition-all ${
        formik.values.which_course_join === "Membership"
          ? "border-blue-500/70 bg-blue-500/10"
          : "border-white/10 bg-[#151515] hover:border-white/20"
      }`}
    >
      <input
        type="radio"
        name="which_course_join"
        value="Membership"
        checked={formik.values.which_course_join === "Membership"}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        className="w-4 h-4 accent-blue-500"
      />

      <span className="text-sm text-white">
        Membership
      </span>
    </label>

    {/* COMBO */}
    <label
      className={`flex items-center gap-3 p-4 rounded-xl border cursor-pointer transition-all ${
        formik.values.which_course_join === "Combo Course"
          ? "border-blue-500/70 bg-blue-500/10"
          : "border-white/10 bg-[#151515] hover:border-white/20"
      }`}
    >
      <input
        type="radio"
        name="which_course_join"
        value="Combo Course"
        checked={formik.values.which_course_join === "Combo Course"}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        className="w-4 h-4 accent-blue-500"
      />

      <span className="text-sm text-white">
        Combo Course
      </span>
    </label>

    {/* Training */}
    <label
      className={`flex items-center gap-3 p-4 rounded-xl border cursor-pointer transition-all ${
        formik.values.which_course_join === "Training"
          ? "border-blue-500/70 bg-blue-500/10"
          : "border-white/10 bg-[#151515] hover:border-white/20"
      }`}
    >
      <input
        type="radio"
        name="which_course_join"
        value="Training"
        checked={formik.values.which_course_join === "Training"}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        className="w-4 h-4 accent-blue-500"
      />

      <span className="text-sm text-white">
        Training
      </span>
    </label>

    {/* OTHER */}
    <label
      className={`flex items-center gap-3 p-4 rounded-xl border cursor-pointer transition-all ${
        formik.values.which_course_join === "Other Courses"
          ? "border-blue-500/70 bg-blue-500/10"
          : "border-white/10 bg-[#151515] hover:border-white/20"
      }`}
    >
      <input
        type="radio"
        name="which_course_join"
        value="Other Courses"
        checked={formik.values.which_course_join === "Other Courses"}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        className="w-4 h-4 accent-blue-500"
      />

      <span className="text-sm text-white">
        Other Courses
      </span>
    </label>

    {/* NO COURSE */}
    <label
      className={`flex items-center gap-3 p-4 rounded-xl border cursor-pointer transition-all ${
        formik.values.which_course_join === "No Course"
          ? "border-blue-500/70 bg-blue-500/10"
          : "border-white/10 bg-[#151515] hover:border-white/20"
      }`}
    >
      <input
        type="radio"
        name="which_course_join"
        value="No Course"
        checked={formik.values.which_course_join === "No Course"}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        className="w-4 h-4 accent-blue-500"
      />

      <span className="text-sm text-white">
        No Course
      </span>
    </label>

  </div>

  {formik.touched.which_course_join &&
    formik.errors.which_course_join && (
      <p className="text-red-500 text-sm mt-2">
        {formik.errors.which_course_join}
      </p>
    )}

</div>


                <div className="border-t border-white/10 pt-6">

                  {/* DESCRIBE ISSUE */}
                  <div className="space-y-2 mt-5">

                    <label
                      className="text-sm font-medium text-gray-200"
                      htmlFor="Describe_issue"
                    >
                     What is your issue or feedback?
                      <span className="text-red-500"> *</span>
                    </label>

                    <textarea
                      className="flex w-full min-h-[130px] bg-[#151515] border border-white/10 text-white rounded-xl px-4 py-3 outline-none transition-all placeholder:text-gray-500 focus:border-blue-500/70 focus:ring-2 focus:ring-blue-500/10 resize-none"
                      placeholder="Tell us your question, issue, suggestion, or feedback..."
                      id="Describe_issue"
                      name="Describe_issue"
                      rows="5"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.Describe_issue}
                    />

                    {formik.touched.Describe_issue &&
                      formik.errors.Describe_issue && (
                        <p className="text-red-500 text-sm">
                          {formik.errors.Describe_issue}
                        </p>
                      )}
                  </div>
                </div>

                {/* SUBMIT */}
                <div className="border-t border-white/10 pt-6">

                  <button
                    className="w-full h-12 rounded-xl bg-gradient-to-r from-blue-600 to-blue-500 text-white font-semibold shadow-lg shadow-blue-500/10 hover:from-blue-500 hover:to-blue-400 hover:shadow-blue-500/20 transition-all duration-200 disabled:opacity-60"
                    type="submit"
                  >
                    Submit 🚀
                  </button>

                  <p className="text-center text-xs text-gray-500 mt-3">
                    We'll review your request and get back to you as soon as
                    possible.
                  </p>

                </div>

              </form>
            </div>
          </div>
        </div>
      </div>


    </>
  );
};

export default FeedbackForm;